import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "not-searched"
}
const _hoisted_2 = {
  key: 1,
  class: "not-searched"
}
const _hoisted_3 = { class: "list table-scrollbar mb-2" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"z-index":"100"}
}
const _hoisted_5 = { key: 0 }

import SearchAttributeContents from "@/components/CvrConvert/VehiclesListParts/SearchAttributeContents.vue"
import HeaderElement from '@/components/CvrConvert/VehiclesListParts/HeaderElement.vue'
import OperationOfficeFilter from "@/components/CvrConvert/OperationOfficeFilter.vue";
import getCvrUploadSummariesResponse from "@/types/responses/getCvrUploadSummaries"
import VehiclesRow from "@/components/CvrConvert/VehiclesListParts/VehiclesRow.vue"
import getCvrUploadSummariesRequest from "@/types/requests/getCvrUploadSummaries"
import cvrUploadSummariesData from "@/types/responses/cvrUploadSummariesData"
import getOperationOfficeType from '@/types/responses/getOperationOffice';
import { Ref, ref, reactive, watch, computed, onMounted } from 'vue'
import getDepartmentResponse from '@/types/responses/getDepartment'
import PaginateWithCount from "@/components/PaginateWithCount.vue"
import getGroupResponse from '@/types/responses/getGroup'
import Api from "@/services/api/ApiServiceFabrick"
import i18n from '@/lang/i18n'
import {
  CVR_UPLOAD_READY_STATUSES,
  CVR_UPLOAD_COMPLETE_STATUSES,
  MANAGEMENT_OFFICE_TYPE,
  SUB_MANAGEMENT_OFFICE_TYPE,
  DEPARTMENT_OFFICE_TYPE
} from "@/services/consts"

type getCvrUploadSummariesParamsType = {
  page: number
} | null | undefined

type selectableItemsType = {
  [key: string]: cvrUploadSummariesData[] | getDepartmentResponse[] | getGroupResponse[];
  vehicle: cvrUploadSummariesData[];
  department: getDepartmentResponse[];
  groups: getGroupResponse[];
};

type searchParamsType = {
  [key: string]: any;
  vehicle: {key: number, value: boolean}[];
  department: {key: number, value: boolean}[];
  groups: {key: number, value: boolean}[];
  upload_statuses: {key: string, value: string}[];
};

type formType = {
  [key: string]: any;
  vehicle: {key: number, value: boolean}[];
  department: {key: number, value: boolean}[];
  groups: {key: number, value: boolean}[];
  upload_statuses: {key: string, value: string}[];
  page: number;
}

const VEHICLE_KEY = 'vehicle'
const DEPARTMENT_KEY = 'department'
const GROUP_KEY = 'groups'
const UPLOAD_STATUS_KEY = 'upload_statuses'

export default /*@__PURE__*/_defineComponent({
  __name: 'VehiclesList',
  props: {
    reload: { type: Function },
    showFlash: { type: Function },
    openCvrList: { type: Function },
    isDisplayCvrList: { type: Boolean },
    selectedVehicle: {},
    createAuthority: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const DEFAULT_UPLOAD_STATUSES = [
  {key: 'ready', value: i18n.global.t('pages.cvr_uploads.waitting')},
  {key: 'completed', value: i18n.global.t('pages.cvr_uploads.requestAvailable')}
]
const NOT_AFFILIATED_COLUMN = {
  id: 0,
  name: i18n.global.t('pages.cvr_uploads.list.notAffiliated')
}
const searchWindowStatus: Ref<boolean> = ref(false);
const selectedElement = reactive({
  bottom: 0,
  left: 0,
  width: 0,
});
const sortKey: Ref<string> = ref(VEHICLE_KEY);
const selectableItems: selectableItemsType = reactive({
  vehicle: [] as cvrUploadSummariesData[],
  department: [] as getDepartmentResponse[],
  groups: [] as getGroupResponse[]
})
const allDepartments: Ref<getDepartmentResponse[]> = ref([])
const allGroups: Ref<getGroupResponse[]> = ref([])
const searchParams: searchParamsType = reactive({
  vehicle: [] as {key: number, value: boolean}[],
  department: [] as {key: number, value: boolean}[],
  groups: [] as {key: number, value: boolean}[],
  upload_statuses: DEFAULT_UPLOAD_STATUSES as {key: string, value: string}[],
})
const form: formType = reactive({
  vehicle: [] as {key: number, value: boolean}[],
  department: [] as {key: number, value: boolean}[],
  groups: [] as {key: number, value: boolean}[],
  upload_statuses: DEFAULT_UPLOAD_STATUSES as {key: string, value: string}[],
  page: 1 as number
})
const sortType: Ref<string> = ref('ASC')
const openWindowKey: Ref<string> = ref('')
const searchedKeys: Ref<string[]> = ref([])
const cvrUploadSummaries: Ref<getCvrUploadSummariesResponse> = ref({
  data: [],
  total_page: 1,
  total: 0,
  per_page: 50,
  current_page: 1
})
const itemsPerPage: Ref<number> = ref(50)
const allElementsCount: Ref<number> = ref(0)
const cvrUploadSummariesList: Ref<cvrUploadSummariesData[]> = ref([])
const isLoading: Ref<boolean> = ref(false)
const isSummariesListLoading: Ref<boolean> = ref(false)
const isOpenSearchWindow: Ref<boolean> = ref(false)
const isDepartment: Ref<boolean> = ref(false)
const isDisplayOperationOfficeFilter = ref(false);
const isSearched: Ref<boolean> = ref(false);
const selectedOperationOfficeId: Ref<number | null> = ref(null)
const selectedOperationOffice: Ref<getOperationOfficeType | null> = ref(null);
const isAllSelectedByWindowKey: Ref<{[key: string]: boolean}> = ref({})

onMounted( async() => {
  await getSelfAccount()
  if (isDisplayOperationOfficeFilter.value) {
    getAutoComplets()
  } else {
    requestApis()
  }
})

const searchTextBoxLabel = computed(() => {
  switch (openWindowKey.value) {
    case VEHICLE_KEY:
      return i18n.global.t('pages.cvr_uploads.list.numberPlate')
    case DEPARTMENT_KEY:
      return i18n.global.t('pages.cvr_uploads.list.department')
    case GROUP_KEY:
      return i18n.global.t('pages.cvr_uploads.list.group')
    default:
      return ''
  }
})

async function getSelfAccount() {
  await Api().getSelfAccount().then((data) => {
    if (
      data.login_organization_type == MANAGEMENT_OFFICE_TYPE ||
      data.login_organization_type == SUB_MANAGEMENT_OFFICE_TYPE
    ) {
      isDisplayOperationOfficeFilter.value = true
    }
  }).catch((error) => {
    const res = error.response
    if (res.status == 403) {
      location.reload();
    }
  })
}

async function requestApis(params: getCvrUploadSummariesParamsType = null) {
  await Promise.all([
    getSummaries(params),
    getAutoComplets()
  ])
  makeSelectableItems();
}

async function getSummaries(params: getCvrUploadSummariesParamsType = null) {
  isSearched.value = true
  await Promise.all([
    getAllCvrUploadSummaries(),
    getCvrUploadSummaries(params)
  ])
}

async function getAutoComplets() {
  await Promise.all([
    getDepartment(),
    getGroups(),
    getSelfOffice()
  ])
}

async function getAllCvrUploadSummaries() {
  isSummariesListLoading.value = true
  let requestParams = {} as getCvrUploadSummariesRequest
  if (selectedOperationOfficeId.value) {
    requestParams.operation_office_id = selectedOperationOfficeId.value
  }

  await Api().getCvrUploadSummaries(requestParams).then((data: cvrUploadSummariesData[]) => {
    cvrUploadSummariesList.value = data
    selectableItems.vehicle = data
    setDefaultStatus(VEHICLE_KEY)
    isSummariesListLoading.value = false
  })
}

async function getDepartment() {
  await Api().autoCompleteDepartments().then((data: getDepartmentResponse[]) => {
    allDepartments.value = data
  })
}

async function getGroups() {
  await Api().autoCompleteGroups(makeGetGroupsQueryParams()).then((data: getGroupResponse[]) => {
    allGroups.value = data
  })
}

function makeGetGroupsQueryParams() {
  return {
    status: 1
  };
}

async function getSelfOffice() {
  Api().getSelfAccount().then((data) => {
    isDepartment.value = data.login_organization_type == DEPARTMENT_OFFICE_TYPE
  })
}

function setDefaultStatus(key: string) {
  selectableItems[key].forEach((value: any) => {
    searchParams[key][value.id] = true
  })
  form[key] = JSON.parse(JSON.stringify(searchParams[key]))
}

async function getCvrUploadSummaries(params: getCvrUploadSummariesParamsType = null) {
  isLoading.value = true
  const requestParams = makeRequestParams(params)
  await Api().getCvrUploadSummaries(requestParams).then((data: getCvrUploadSummariesResponse) => {
    if (isSearched.value) {
      cvrUploadSummaries.value = data
      form.page = data.current_page
      allElementsCount.value = data.total
      itemsPerPage.value = data.per_page
    }
    isLoading.value = false
  })
}

function makeSelectableItems() {
  selectableItems.department = filterBySummaryVehicles(allDepartments.value, DEPARTMENT_KEY)
  setDefaultStatus(DEPARTMENT_KEY)
  selectableItems.groups = filterBySummaryVehicles(allGroups.value, GROUP_KEY)
  setDefaultStatus(GROUP_KEY)
}

function filterBySummaryVehicles(values: getDepartmentResponse[] | getGroupResponse[], attribute: string) {
  let items: getDepartmentResponse[] | getGroupResponse[] = []
  values.forEach((value: getDepartmentResponse | getGroupResponse) => {
    selectableItems.vehicle.forEach((vehicle: cvrUploadSummariesData) => {
      if (attribute == DEPARTMENT_KEY) {
        if (!isDepartment.value && vehicle.department_id && isIncluedsNotAffiliatedColumn(items)) {
          items.push(NOT_AFFILIATED_COLUMN);
        }
        if (isAddSelectableDepartment(value, vehicle, items)) {
          return items.push(value);
        }
      }
      if (attribute == GROUP_KEY) {
        if (!vehicle.group_ids.length && isIncluedsNotAffiliatedColumn(items)) {
          items.push(NOT_AFFILIATED_COLUMN);
        }
        if (isAddSelectableGroups(value, vehicle, items)) {
          return items.push(value);
        }
      }
    })
  })
  return items
}

function isIncluedsNotAffiliatedColumn(items: any[]) {
  return !items.find((item) => {
    return item.id === 0
  })
}

function isAddSelectableDepartment(value: getDepartmentResponse, vehicle: cvrUploadSummariesData, items: getDepartmentResponse[]) {
  return value.id == vehicle.department_id && !items.find((item) => { return item.id == value.id })
}

function isAddSelectableGroups(value: getGroupResponse, vehicle: cvrUploadSummariesData, items: getGroupResponse[]) {
  return vehicle.group_ids.includes(value.id) && !items.find((item) => { return item.id == value.id })
}

function makeRequestParams(params: getCvrUploadSummariesParamsType = null): getCvrUploadSummariesRequest {
  return {
    operation_office_id: selectedOperationOfficeId.value,
    device_ids: makeRequestIds(form.vehicle, VEHICLE_KEY, 'device_id'),
    department_ids: makeRequestIds(form.department, DEPARTMENT_KEY, 'id'),
    group_ids: makeRequestIds(form.groups, GROUP_KEY, 'id'),
    statuses: makeStatuses(form.upload_statuses),
    sort_key: makeRequestSortKey(),
    sort_type: sortType.value,
    page: params?.page ?? form.page
  }
}

function makeRequestIds(values: any, key: string, addAttribute: string) {
  let ids: (number | null)[] = []
  let falseCount = 0
  values.forEach((value: boolean | null, id: number) => {
    if (value === false) {
      return falseCount++
    }
    if (value) {
      if (id === 0) {
        return ids.push(null)
      }
      selectableItems[key].find((item: any) => {
        if (item.id == id) {
          ids.push(item[addAttribute])
        }
      })
    }
  })
  if (falseCount === 0) {
    return []
  }
  return ids
}

function makeStatuses(statuses: any) {
  if (!statuses.length || statuses.length == 2) {
    return [];
  }
  let responseStatuses: string[] = []
  statuses.forEach((status: {key: string, value: string}) => {
    if (status.key == 'ready') {
      responseStatuses.push(...CVR_UPLOAD_READY_STATUSES)
    } else if (status.key == 'completed') {
      responseStatuses.push(...CVR_UPLOAD_COMPLETE_STATUSES)
    }
  })
  return responseStatuses
}

function makeRequestSortKey() {
  switch(sortKey.value) {
    case DEPARTMENT_KEY:
      return 'department_name'
    case GROUP_KEY:
      return 'group_names'
    default:
      return 'number_plate'
  }
}

const openSearchWindow = (key: string) => {
  if (props.isDisplayCvrList) return
  isOpenSearchWindow.value = true
  if (sortKey.value != key) sortType.value = 'ASC'
  openWindowKey.value = key

  const selectedContent: HTMLElement | null = document.getElementById(key)
  const element = selectedContent?.getBoundingClientRect()
  if (!element) return
  selectedElement.bottom = element.bottom + window.scrollY + 5
  selectedElement.left = element.left + window.scrollX
  selectedElement.width = element.width

  changeWindowStatus(true)
}

const changeSortType = (type: string) => {
  sortType.value = type
  sortKey.value = openWindowKey.value
  getCvrUploadSummaries()
  changeWindowStatus(false)
}

const changeWindowStatus = (status: boolean) => {
  if (!status) {
    searchParams[openWindowKey.value] = JSON.parse(JSON.stringify(form[openWindowKey.value]));
  }
  searchWindowStatus.value = status
}

const search = (key: string) => {
  form.page = 1
  form[key] = JSON.parse(JSON.stringify(searchParams[key]))
  getCvrUploadSummaries()
  changeWindowStatus(false)
}

async function searchSummaries(params: getCvrUploadSummariesParamsType) {
  await getSummaries(params)
  makeSelectableItems();
}

function setIsAllSelectedByWindowKey($event: { windowKey: string, isAllSelected: boolean }) {
  isAllSelectedByWindowKey.value[$event.windowKey] = $event.isAllSelected
}

const vehicleWidth = computed(() => {
  return props.isDisplayCvrList ? 'vehicle-header closed' : 'vehicle-heade';
})

const acordionItemStyle = computed(() => {
  return props.isDisplayCvrList ? 'display: none' : '';
})

const acordionHeaderClassName = computed(() => {
  return props.isDisplayCvrList ? 'acordion-headers closed' : 'acordion-headers';
})

const listClassName = computed(() => {
  return props.isDisplayCvrList ? 'cvr-list-table close' : 'cvr-list-table'
})

watch(() => form.page, () => {
  getCvrUploadSummaries()
})

watch(() => selectedOperationOffice.value, (operationOffice) => {
  selectedOperationOfficeId.value = operationOffice?.id ?? null
  if (operationOffice) {
    const params = {
      page: 1
    }
    return searchSummaries(params)
  }
  isSearched.value = false
  cvrUploadSummaries.value.data = []
})

__expose({ getCvrUploadSummaries })

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(OperationOfficeFilter, {
      modelValue: selectedOperationOffice.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOperationOffice).value = $event))
    }, null, 8, ["modelValue"]), [
      [_vShow, !__props.isDisplayCvrList && isDisplayOperationOfficeFilter.value]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["list mt-3 position-relative", listClassName.value])
    }, [
      (isDisplayOperationOfficeFilter.value && !isSearched.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.list.pleaseSelectOperationOffice')), 1)
          ]))
        : (isLoading.value || isSummariesListLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.requestPanel.loading')), 1)
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_table, {
          class: _normalizeClass(acordionHeaderClassName.value)
        }, {
          default: _withCtx(() => [
            _createElementVNode("thead", _hoisted_4, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  id: VEHICLE_KEY,
                  class: _normalizeClass(["col-md-2 searchable", vehicleWidth.value]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openSearchWindow(VEHICLE_KEY)))
                }, [
                  _createVNode(HeaderElement, {
                    sortKey: sortKey.value,
                    sortType: sortType.value,
                    elementKey: VEHICLE_KEY,
                    isAllSelected: isAllSelectedByWindowKey.value[VEHICLE_KEY],
                    searchable: true,
                    sortable: true,
                    title: _unref(i18n).global.t('pages.cvr_uploads.list.numberPlate'),
                    titleWidth: props.isDisplayCvrList ? '100%' : '60%'
                  }, null, 8, ["sortKey", "sortType", "isAllSelected", "title", "titleWidth"])
                ], 2),
                _createElementVNode("th", {
                  id: DEPARTMENT_KEY,
                  class: "col-md-2 searchable",
                  style: _normalizeStyle(acordionItemStyle.value),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (openSearchWindow(DEPARTMENT_KEY)))
                }, [
                  _createVNode(HeaderElement, {
                    sortKey: sortKey.value,
                    sortType: sortType.value,
                    elementKey: DEPARTMENT_KEY,
                    isAllSelected: isAllSelectedByWindowKey.value[DEPARTMENT_KEY],
                    searchable: true,
                    sortable: true,
                    title: _unref(i18n).global.t('pages.cvr_uploads.list.department'),
                    titleWidth: "60%"
                  }, null, 8, ["sortKey", "sortType", "isAllSelected", "title"])
                ], 4),
                _createElementVNode("th", {
                  id: GROUP_KEY,
                  class: "col-md-2 searchable",
                  style: _normalizeStyle(acordionItemStyle.value),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (openSearchWindow(GROUP_KEY)))
                }, [
                  _createVNode(HeaderElement, {
                    sortKey: sortKey.value,
                    sortType: sortType.value,
                    elementKey: GROUP_KEY,
                    isAllSelected: isAllSelectedByWindowKey.value[GROUP_KEY],
                    searchable: true,
                    sortable: true,
                    title: _unref(i18n).global.t('pages.cvr_uploads.list.group'),
                    titleWidth: "60%"
                  }, null, 8, ["sortKey", "sortType", "isAllSelected", "title"])
                ], 4),
                _createElementVNode("th", {
                  class: "col-md-1 text-center",
                  style: _normalizeStyle(acordionItemStyle.value)
                }, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.list.deviceModelType')), 5),
                _createElementVNode("th", {
                  class: "col-md-1 text-center",
                  style: _normalizeStyle(acordionItemStyle.value)
                }, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.list.svrCount')), 5),
                _cache[7] || (_cache[7] = _createElementVNode("th", { class: "col-md-1" }, null, -1)),
                _createElementVNode("th", {
                  id: UPLOAD_STATUS_KEY,
                  class: "col-md-2 searchable",
                  style: _normalizeStyle(acordionItemStyle.value),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (openSearchWindow(UPLOAD_STATUS_KEY)))
                }, [
                  _createVNode(HeaderElement, {
                    sortKey: sortKey.value,
                    sortType: sortType.value,
                    elementKey: UPLOAD_STATUS_KEY,
                    isAllSelected: isAllSelectedByWindowKey.value[UPLOAD_STATUS_KEY],
                    searchable: true,
                    sortable: true,
                    title: _unref(i18n).global.t('pages.cvr_uploads.list.uploadStatus'),
                    titleWidth: "70%"
                  }, null, 8, ["sortKey", "sortType", "isAllSelected", "title"])
                ], 4)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (!isLoading.value && !isSummariesListLoading.value && !cvrUploadSummaries.value.data.length && isSearched.value)
                ? (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.list.noVehicle')), 1))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(cvrUploadSummaries.value.data, (item, index) => {
                    return (_openBlock(), _createBlock(VehiclesRow, {
                      key: index,
                      item: item,
                      reload: props.reload,
                      showFlash: props.showFlash,
                      vehicleWidth: vehicleWidth.value,
                      acordionItemStyle: acordionItemStyle.value,
                      isDisplayCvrList: props.isDisplayCvrList,
                      vehicle: props.selectedVehicle,
                      searchWindowStatus: searchWindowStatus.value,
                      createAuthority: props.createAuthority,
                      onOpenCvrList: props.openCvrList
                    }, null, 8, ["item", "reload", "showFlash", "vehicleWidth", "acordionItemStyle", "isDisplayCvrList", "vehicle", "searchWindowStatus", "createAuthority", "onOpenCvrList"]))
                  }), 128))
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      (!props.isDisplayCvrList && isSearched.value)
        ? (_openBlock(), _createBlock(PaginateWithCount, {
            key: 2,
            class: "justify-end",
            totalPage: cvrUploadSummaries.value.total_page,
            modelValue: form.page,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.page) = $event)),
            itemsPerPage: itemsPerPage.value,
            allElementsCount: allElementsCount.value,
            showItemCount: true
          }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"]))
        : _createCommentVNode("", true)
    ], 2),
    (searchWindowStatus.value)
      ? (_openBlock(), _createBlock(SearchAttributeContents, {
          key: 0,
          modelValue: searchParams[openWindowKey.value],
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchParams[openWindowKey.value]) = $event)),
          filteredItems: form,
          items: selectableItems,
          windowKey: openWindowKey.value,
          sortKey: sortKey.value,
          sortType: sortType.value,
          label: searchTextBoxLabel.value,
          searchedKeys: searchedKeys.value,
          summariesList: cvrUploadSummariesList.value,
          style: _normalizeStyle(`position: absolute; top: ${selectedElement.bottom}px; left: ${selectedElement.left}px;`),
          width: selectedElement.width,
          onChangeSortType: changeSortType,
          onCloseWindow: changeWindowStatus,
          onSearch: search,
          onSetIsAllSelected: setIsAllSelectedByWindowKey
        }, null, 8, ["modelValue", "filteredItems", "items", "windowKey", "sortKey", "sortType", "label", "searchedKeys", "summariesList", "style", "width"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})